export default __webpack_public_path__ + "static/media/gallery-4-4.f770757d.webp";